import { useState } from "react";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { colorsList } from "../../data/colorsList";
import { strLang } from "../../functions/strLang";
import StdButton from "../../components/StdButton";
export default function MonthsList({
  currentDate,
  startWritingCalendar,
  closeMsg,
}) {
  const [year, setYear] = useState(currentDate[0]);
  const mList = strLang("monthsFullName");
  const indexedList = [
    [mList[0], mList[1]],
    [mList[2], mList[3]],
    [mList[4], mList[5]],
    [mList[6], mList[7]],
    [mList[8], mList[9]],
    [mList[10], mList[11]],
  ];
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <ArrowLeftIcon
          style={{ fontSize: 40 }}
          onClick={() => {
            setYear(year - 1);
          }}
        />
        <span style={{ color: colorsList.blue, fontSize: 20 }}>{year}</span>
        <ArrowRightIcon
          style={{ fontSize: 40 }}
          onClick={() => {
            setYear(year + 1);
          }}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
        {indexedList.map((e, index) => (
          <div
            key={index}
            style={{ display: "flex", flexDirection: "row", gap: 5 }}
          >
            {e.map((v, idx) => (
              <StdButton
                key={idx}
                label={v}
                onClick={() => {
                  startWritingCalendar([year, index * 2 + (idx + 1)]);
                  closeMsg();
                }}
                width={100}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
